import React, {useEffect, useRef, useState} from "react";
import {UpdatePartnerBankInfo} from "../../Actions/partnerBankInfoUpdateAction";
import {useDispatch, useSelector} from "react-redux";
import {CARD_UPDATE_STATES, PARTNER_CREDIT_UPDATE_CARD_STATE} from "../Payments/creditCardInfoSection";
import axios from "axios";
import {API_RESPONSE_MESSAGE} from "../../Reducers/apiResponseMessagesReducer";
import {getPayoutInfo} from "../../Actions/payoutBankInfoAction";
import GeneralModal from "../CommonComponents/generalModal";

const PARTNER_BANK_INFO = "PARTNER_BANK_INFO";

const BankInfoHolder = () => {
    const updateState = useSelector(state => state.partnerCreditCardUpdateState);
    const apiResponseMessage = useSelector(state => state.apiResponseMessages);
    const dispatch = useDispatch();
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [updateFailed, setUpdateFailed] = useState(false);
    const [ipData, setIpData] = useState(null);
    const nameRef = useRef(null);
    const routingRef = useRef(null);
    const accRef = useRef(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const emailRef = useRef(null);

    const updateBankInfo = (ev) => {
        ev.preventDefault();
        let accHolderName = nameRef.current.value;
        let routingNumber = routingRef.current.value;
        let accNumber = accRef.current.value;
        let firstName = firstNameRef.current.value;
        let lastName = lastNameRef.current.value;
        let email = emailRef.current.value;
        dispatch({
            type: PARTNER_CREDIT_UPDATE_CARD_STATE,
            payload: CARD_UPDATE_STATES.pending
        })
        dispatch(UpdatePartnerBankInfo(routingNumber, accHolderName, accNumber, firstName, lastName, email, ipData.ip));
    }

    useEffect(() => {
        axios.get('https://ipapi.co/jsonp/')
            .then((response) => {
                const data = JSON.parse(response.data.substring(9, response.data.length - 2)); // Removing "callback(" and ");" to parse JSON
                setIpData(data);
            })
            .catch((error) => {
                console.error('Error fetching IP data:', error);
            });
    }, []);

    useEffect(() => {
        if (updateState === CARD_UPDATE_STATES.success) {
            document.getElementById('payout-bank-info-modal-close').click();
            setUpdateSuccess(true);
            setTimeout(() => {
                setUpdateSuccess(false);
                dispatch({
                    type: PARTNER_CREDIT_UPDATE_CARD_STATE,
                    payload: CARD_UPDATE_STATES.none
                });

                dispatch({
                    type: API_RESPONSE_MESSAGE,
                    payload: null
                });
            }, 5000);
            dispatch(getPayoutInfo());
        } else if (updateState === CARD_UPDATE_STATES.failed) {
            document.getElementById('payout-bank-info-modal-close').click();
            setUpdateFailed(true);
            setTimeout(() => {
                setUpdateFailed(false);
                dispatch({
                    type: PARTNER_CREDIT_UPDATE_CARD_STATE,
                    payload: CARD_UPDATE_STATES.none
                });

                dispatch({
                    type: API_RESPONSE_MESSAGE,
                    payload: null
                });
            }, 10000);
        }
    }, [updateState]);

    return (
        <div className="py-4">
            <div className="bankInfoSub w-100 pb-3">Shipday will use your bank details to send you your affiliate commissions
                directly to your bank account on a monthly basis.
            </div>
            <GeneralModal modalId={"payout-bank-info-modal"} title={"Add bank information"} showFooterBtn={false} btnText={"Add bank information"}>
                <form onSubmit={updateBankInfo} className="d-flex flex-column payout-info-form text-start">
                    <div className="pt-3 payout-info-div">
                        <div className="w-100">
                            <label className='form-label'>First Name</label>
                            <input required={true} ref={firstNameRef} className='form-control' placeholder={"First Name"}></input>
                        </div>
                        <div className="w-100">
                            <label className='form-label'>Last Name</label>
                            <input required={true} ref={lastNameRef} className='form-control' placeholder={"Last Name"}></input>
                        </div>
                    </div>
                    <div>
                        <label className='form-label'>Email Address</label>
                        <input required={true} ref={emailRef} className='form-control' placeholder='Email Address' type="email"></input>
                    </div>

                    <div>
                        <label className='form-label'>Account Holder Name</label>
                        <input required={true} ref={nameRef} className='form-control' placeholder='Account Holder Name'></input>
                    </div>

                    <div>
                        <label className='form-label'>Account Number</label>
                        <div className="bankInfoSub">A unique set of digits designating your individual bank account.
                        </div>
                        <input required={true} ref={accRef} className='form-control' placeholder='Account Number'></input>
                    </div>

                    <div>
                        <label className='form-label'>Routing Number</label>
                        <div className="bankInfoSub">A nine-digit code identifying your bank for electronic transfers.
                        </div>
                        <input required={true} ref={routingRef} className='form-control' placeholder='Rounting Number'></input>
                    </div>
                    <div className="py-3 payout-info-div justify-content-end">
                        <button type="submit" className="btn sd-primary-btn bankInfoInput fw-bold px-4"
                                disabled={updateState === CARD_UPDATE_STATES.pending}>
                            {updateState === CARD_UPDATE_STATES.pending &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"/>}
                            <span>{updateState === CARD_UPDATE_STATES.pending? 'Updating' : 'Update'}</span>
                        </button>
                    </div>
                </form>
            </GeneralModal>
            {updateSuccess && <div className="alert alert-success text-center mt-2" role="alert">
                Bank Information Updated
            </div>}
            {updateFailed && <div className="alert alert-danger text-center mt-2" role="alert">
                Bank Information Update Failed. {apiResponseMessage}
            </div>}
        </div>

    )
}

export default BankInfoHolder;
export {PARTNER_BANK_INFO};
